import { render, staticRenderFns } from "./projectSetup.vue?vue&type=template&id=0f142ee7&"
import script from "./projectSetup.vue?vue&type=script&lang=js&"
export * from "./projectSetup.vue?vue&type=script&lang=js&"
import style0 from "./projectSetup.vue?vue&type=style&index=0&id=0f142ee7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports